module.exports = __webpack_public_path__ + "img/2_2-finanziario-filiale-0.b60a60f0.png";